
$.formUtils.addValidator({
	name : 'phone',
	validatorFunction : function(val, $el, conf) {
		var actualValue = $el.val(); // needed because validator framework trims the 'value' argument
		if('' != actualValue){
			var sRe = $el.valAttr('phone') || '^[0-9\\+][0-9\\s]{5,23}[0-9]$';
			var regexp = new RegExp(sRe);
			return regexp.test(actualValue);
		} else {
			return true;
		}
	},
	errorMessage : 'This field is not a valid phone number',
	errorMessageKey: 'badPhoneNumber'
});
